@if (activated) {
  <div class="slide__cont">
    <div #slide class="slide__wrapper">
      <div class="slide__buffer">
        <div class="slide__carousel" [ngStyle]="{ gap: gap }">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    @if (mechanicalDisplacement) {
      @if (showl) {
        <app-ds-button-icon
          class="slide__buttons slide__buttons--previous" 
          [type]="buttonType"
          [icon]="icon.ChevronLeft"
          [buttonSize]="buttonIconSize"
          [iconSize]="20"
          (click)="previous()">
        </app-ds-button-icon>
      }
      @if (showr) {
        <app-ds-button-icon
          class="slide__buttons slide__buttons--next" 
          [type]="buttonType"
          [icon]="icon.ChevronRight"
          [buttonSize]="buttonIconSize"
          [iconSize]="20"
          (click)="next()">
        </app-ds-button-icon>
      }
    }
  </div>
}